import { Helmet } from 'react-helmet-async';
import { siteUrl } from '../lib/siteUrl';

const BRAND = 'ComfortTool';

export function JsonLdSite() {
  const base = siteUrl();
  const graph = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: BRAND,
        url: `${base}/`,
        inLanguage: 'nl-NL',
      },
      {
        '@type': 'Organization',
        name: BRAND,
        url: `${base}/`,
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(graph)}</script>
    </Helmet>
  );
}
